import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { mdrQueries } from '@/features/mdr/queries'

import { getCurrentTenant } from '@/shared/auth/store'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { TableSkeleton } from '@/components/skeletons/table-skeleton'

const ReportList = lazy(() => import('@/features/mdr/components/report-list'))

export const Route = createFileRoute('/_dashboard/mdr/executive-reports')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		// Prefetch the reports for the tenant
		if (tenant) {
			queryClient.prefetchQuery(mdrQueries.reports(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Executive Reports | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: PendingComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<div className="flex flex-col gap-4">
			<ErrorBoundary>
				<Suspense fallback={<TableSkeleton rows={4} />}>
					<ReportList />
				</Suspense>
			</ErrorBoundary>
		</div>
	)
}

function PendingComponent() {
	return <TableSkeleton rows={4} />
}
